export default __webpack_public_path__ + "static/media/Dsptire.d02790ef.png";